export default "__VITE_ASSET__13e34889__"